/** Shared dropdown options for Spot profile order screens (wired to `/spot/v1/me/*`). */

export const TYPE_OPTIONS = [
  { value: "all", label: "All" },
  { value: "limit", label: "Limit" },
  { value: "market", label: "Market" },
  { value: "stop_limit", label: "Stop Limit" },
  { value: "stop_market", label: "Stop Market" },
];

export const SIDE_OPTIONS = [
  { value: "all", label: "All" },
  { value: "buy", label: "Buy" },
  { value: "sell", label: "Sell" },
];

/**
 * Dropdown options from `GET` pairs (header / ProfileContext shape):
 * each item uses `base_currency` + `quote_currency` (`short_name` fallback for base).
 */
export function buildPairFilterOptions(pairList) {
  const seen = new Set();
  const rest = [];
  for (const p of Array.isArray(pairList) ? pairList : []) {
    const base = String(p.base_currency ?? p.short_name ?? "").trim();
    const quote = String(p.quote_currency ?? "").trim();
    if (!base || !quote) continue;
    const value = `${base}_${quote}`.replace(/\s+/g, "").toLowerCase();
    if (seen.has(value)) continue;
    seen.add(value);
    rest.push({
      value,
      label: `${base.toUpperCase()}/${quote.toUpperCase()}`,
    });
  }
  rest.sort((a, b) => a.label.localeCompare(b.label));
  return [{ value: "all", label: "All" }, ...rest];
}

/** Order-only `type` → engine enum */
export function spotUiOrderTypeToApi(uiType) {
  const k = String(uiType || "").toLowerCase();
  if (!k || k === "all") return "";
  const map = {
    limit: "LIMIT",
    market: "MARKET",
    stop_limit: "STOP_LIMIT",
    stop_market: "STOP_MARKET",
  };
  return map[k] || "";
}

export function spotPairsDropdownToApi(pairKey) {
  if (!pairKey || pairKey === "all") return "";
  const u = String(pairKey).replace(/_/g, "").toUpperCase();
  return u;
}

export const ORDER_HISTORY_STATUS_OPTIONS = [
  { value: "all", label: "All" },
  { value: "PARTIALLY_FILLED", label: "Partially filled" },
  { value: "FILLED", label: "Filled" },
  { value: "CANCELLED", label: "Cancelled" },
  { value: "REJECTED", label: "Rejected" },
  { value: "EXPIRED", label: "Expired" },
];

export function spotSideDropdownToApi(sideKey) {
  if (!sideKey || sideKey === "all") return "";
  const s = String(sideKey).toLowerCase();
  if (s === "buy") return "BUY";
  if (s === "sell") return "SELL";
  return String(sideKey).toUpperCase();
}
